<p>
  Sub-Component {{ name }}
</p>
